import React from 'react'
import Hero from '../Component/HeroSection/Hero'
import Info from '../Component/InfoSection/Info'
import Cards from '../Component/Card/Cards'
import Contact from '../Component/Contacts/Contact'

import Payments from '../Component/PaymentCard/Payments'
import Info2 from '../Component/InfoReading/Info2'


const Home = () => {
    return (
        <>
        <Hero/>
        <Info/>     
        <Cards/>
           <Info2/>
        <Payments/>
              <Contact/>
        
        </>
        
    )
}

export default Home
